// Helpers for browser-side DOM utilities that need robust fallbacks across
// sandboxed iframes and varied browser permission models.

const IS_DEV = process.env.NODE_ENV !== "production";

function debug(message, error) {
  if (IS_DEV && error) {
    // Surface failures only in dev so we never spam production logs.
    // eslint-disable-next-line no-console
    console.debug(`[dom.js] ${message}:`, error);
  }
}

// Robust copy-to-clipboard with fallback for sandboxed iframes / older browsers.
export async function copyToClipboard(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (err) {
    debug("navigator.clipboard.writeText failed", err);
  }
  return legacyCopy(text);
}

function legacyCopy(text) {
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    ta.style.pointerEvents = "none";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch (err) {
    debug("legacy execCommand copy failed", err);
    return false;
  }
}

// Opens a Catawiki lot URL, gracefully falling back across sandbox restrictions.
export function openInNewTab(url) {
  let opened = null;
  try {
    opened = window.open(url, "_blank");
  } catch (err) {
    debug("window.open blocked", err);
  }
  if (opened && !opened.closed) return;
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url;
      return;
    }
  } catch (err) {
    debug("top-frame navigation blocked (cross-origin)", err);
  }
  window.location.href = url;
}
